import React from 'react'
import { Box, LinearProgress } from '@mui/material'

import { dsColorNew } from '@palette'


// The progress line right under the tabs band: visible during any fetch or save, doesn't shift layout
export function AdminProgress({ active }) {
	return <Box sx={{ position: 'sticky', top: 0, zIndex: 3, height: 3, mt: -3, mb: 3 }}>
		{active && <LinearProgress sx={{ height: 3 }}/>}
	</Box>
}

// A card of the admin: the white card of the module with the app's padding
export const adminCardSx = { p: 2.5, mb: 3 }

// Fields inside the admin cards (table cells and forms) in the app's light input look
export const adminFieldsSx = {
	'& .MuiOutlinedInput-root': {
		backgroundColor: dsColorNew.filterInputBg,
		borderRadius: '8px',
		fontSize: 13,
		'& .MuiOutlinedInput-notchedOutline': { borderColor: dsColorNew.grayBorder },
		'&:hover .MuiOutlinedInput-notchedOutline': { borderColor: dsColorNew.textSubtle },
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: dsColorNew.appBlue, borderWidth: 1 },
		'&.Mui-disabled': { backgroundColor: dsColorNew.pillTrackBg },
	},
	'& .MuiInputBase-input::placeholder': { color: dsColorNew.textSubtle, opacity: 1 },
	'& .MuiInputLabel-root': { fontSize: 13, color: dsColorNew.textMuted },
	'& .MuiInputLabel-shrink': { backgroundColor: dsColorNew.white, px: 0.5, ml: -0.5 },
	'& .MuiFormHelperText-root': { fontSize: 12, color: dsColorNew.textSubtle },
	// Selected groups as the soft blue chips of the app's filters
	'& .MuiAutocomplete-tag': {
		backgroundColor: dsColorNew.pillActiveBg, color: dsColorNew.appBlue, fontWeight: 500,
		'& .MuiChip-deleteIcon': { color: dsColorNew.appBlue, opacity: 0.7, '&:hover': { color: dsColorNew.appBlue, opacity: 1 } },
	},
	'& code': { fontFamily: 'inherit', fontSize: 12.5, color: dsColorNew.textDark },
}

// Cells of a row tinted: soft green right after a save, soft amber while still unassigned
export const rowToneSx = ({ saved = false, unassigned = false } = {}) => ({
	'& > .MuiTableCell-root': {
		transition: 'background-color 600ms ease',
		...(saved ? { backgroundColor: `${dsColorNew.successBg} !important` }
			: unassigned ? { backgroundColor: `${dsColorNew.noteAmberBg} !important` } : {}),
	},
})

// The grey icon buttons of the table rows (delete, add)
export const rowIconButtonSx = { color: dsColorNew.textMuted, fontSize: 15, p: 0.75, pr: 0.75, '&:hover': { color: dsColorNew.textDark } }
export const rowDeleteButtonSx = { ...rowIconButtonSx, '&:hover': { color: dsColorNew.dangerRed, backgroundColor: dsColorNew.dangerBg } }

// A short helper sentence under or beside a table
export const adminHintSx = { fontSize: 12.5, color: dsColorNew.textMuted }
